const RETRY_KEY = "app-chunk-retry";

const isChunkLoadError = (reason) => {
  if (!reason) return false;
  const message = typeof reason.message === "string" ? reason.message : "";
  return reason.name === "ChunkLoadError" || /Loading chunk \S+ failed/i.test(message);
};

const claimSingleRetry = () => {
  try {
    if (sessionStorage.getItem(RETRY_KEY) === "1") return false;
    sessionStorage.setItem(RETRY_KEY, "1");
    return true;
  } catch (e) {
    return false;
  }
};

export const registerChunkRetryGuard = () => {
  window.addEventListener("unhandledrejection", (event) => {
    if (!isChunkLoadError(event?.reason)) return;
    if (!claimSingleRetry()) return;
    window.location.reload();
  });
};
